import type { ConnectorDto } from "@/lib/gen-api";
import type { ComponentType } from "react";
import { FirefliesLogo } from "./FirefliesLogo";

export type ConnectorProviderId = ConnectorDto["provider"];

type ConnectorAuthType = "oauth" | "api-key";

type ConnectorOption = {
  id: ConnectorProviderId;
  name: string;
  description: string;
  authType: ConnectorAuthType;
  apiKeyLabel?: string;
  apiKeyHelpUrl?: string;
  Logo: ComponentType<{ className?: string }>;
};

export const CONNECTOR_OPTIONS: ConnectorOption[] = [
  {
    id: "FIREFLIES",
    name: "Fireflies",
    description: "Import meeting notes, transcripts, and AI summaries.",
    authType: "api-key",
    apiKeyLabel: "Fireflies API key",
    apiKeyHelpUrl: "https://app.fireflies.ai/integrations/custom/fireflies",
    Logo: FirefliesLogo,
  },
];

export function getConnectorOption(
  provider: ConnectorProviderId,
): ConnectorOption | undefined {
  // Safe guard for future providers
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return CONNECTOR_OPTIONS.find((option) => option.id === provider);
}

export function getConnectorLabel(provider: ConnectorProviderId): string {
  return getConnectorOption(provider)?.name ?? provider;
}

export function connectorRequiresApiKey(
  provider: ConnectorProviderId,
): boolean {
  return getConnectorOption(provider)?.authType === "api-key";
}
